import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantUserRemoveManyMutation } from "@/v2-backoffice-client/tenant/user/remove/many/tenant.user.remove.many.mutation"

export type TenantUserRemoveManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  userTenantIds: number[]
  onCompleted?(): void
}

function TenantUserRemoveManyButton(props: TenantUserRemoveManyButtonProps) {
  const { userTenantIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props

  const count = userTenantIds.length
  const [remove, { loading, error }] = useTenantUserRemoveManyMutation({
    onCompleted,
  })

  errorToast(error, {
    title: `Failed to remove ${count} user(s) from the team`,
  })

  return (
    <ConfirmButton
      id="tenant-user-remove-many-button"
      variant="destructive"
      size="tiny"
      iconSrc="trash"
      content="Remove users from team"
      confirmContent={
        confirmContent ??
        `Are you sure you want to remove ${count} user(s) from the team?`
      }
      isLoading={loading}
      onConfirm={() => {
        remove({ variables: { ids: userTenantIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default TenantUserRemoveManyButton
